import { useState, useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faHome } from "@fortawesome/free-solid-svg-icons"
import { toast } from 'react-toastify'
import { useEmailPlainMutation } from '../features/emails/emailsApiSlice'
import { useNavigate, useLocation } from "react-router-dom"
import { Editor } from "@tinymce/tinymce-react"
import useAuth from '../hooks/useAuth'



const ContactUs = () => {


	const navigate = useNavigate()
	const editorRef = useRef(null);

	const USER_REGEX = /^\/dash\/help(\/)?$/
	const { pathname } = useLocation()

	let contactTitle = "Contact Us"
	let isUser=false
	if (USER_REGEX.test(pathname)) {
		isUser=true
		contactTitle="Email Helpdesk"
	}

	const { email } = useAuth()
	
	const sendTo= 'webmaster@smidtmanagement.com'
	const sendFrom = 'webmaster@smidtmanagement.com'
	const [replyTo, setReplyTo] = useState(email)
	const [subjectText, setSubjectText] = useState('')
	const [htmlText, setHtmlText] = useState('')


	// Send email function
	const [sendEmail, {data}] = useEmailPlainMutation()

	useEffect(() => {
		if(data) {
			if (data.message) {
				toast.error(<>Email was NOT Send:<br/>{data.message}</>);
			} else {
				toast.success("Email was Send");
				onHomeClicked()
			}
		}

	}, [data, navigate]) // eslint-disable-line react-hooks/exhaustive-deps


	// field changes
	const onReplyToChanged = e => setReplyTo(e.target.value)
	const onSubjectChanged = e => setSubjectText(e.target.value)


	// check save and send email
	let canSave
	canSave = [sendTo, sendFrom, replyTo, subjectText, htmlText].every(Boolean)
	const onSendEmailClicked = async (e) => {
		e.preventDefault()

		if(canSave) {
			await sendEmail({ sendTo, sendFrom, replyTo, subjectText, htmlText})
		} else {
			toast.error('All fields are required');
		}
	}

	const onHomeClicked= () => {
		if (isUser) {
			navigate('/dash')
		} else {
			navigate('/')
		}
	}




	return (
		<section id="main_content">
			<header className="text-steel mt-5">
				<h1 className='mt-5'><FontAwesomeIcon icon={faEnvelope} style={{fontSize:"30px", marginRight:"5px"}} />{contactTitle}</h1>
			</header>
			<main>
				<form onSubmit={e => e.preventDefault()}>
					<div className="row mb-3">
						<div className="col-md-8">
							<label className="form-label" htmlFor="replyTo">
								From:
							</label>
							<input
								className="form-control"
								id="replyTo"
								name="replyTo"
								type="email"
								autoComplete="off"
								placeholder='Enter your email'
								value={replyTo}
								onChange={onReplyToChanged}
							/>
						</div>
					</div>

					<div className="row mb-3">
						<div className="col-md-8">
							<label className="form-label" htmlFor="subject">
								Subject:
							</label>
							<input
								className="form-control"
								id="subject"
								name="subject"
								type="text"
								autoComplete="off"
								value={subjectText}
								onChange={onSubjectChanged}
							/>
						</div>
					</div>

					<div className="row mb-3">
						<div className="col-md-8">
							<Editor
								apiKey="mprrt6hl7gkebqsue1jr2da25cai059a5vwnw9xtv4smrptk"
								onInit={(evt, editor) => (editorRef.current = editor)}
								value={htmlText}
								onEditorChange={(newContent) => setHtmlText(newContent)}
								init={{
									skin: (localStorage.getItem('theme')==='dark' ? "oxide-dark" : "oxide"),
									content_css: (localStorage.getItem('theme')==='dark' ? "dark" : "default"),
									height: 300,
									menubar: true,
									plugins: 'anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
									toolbar: 'align | numlist bullist indent outdent | bold italic underline strikethrough backcolor fontsize | undo redo | blocks fontfamily | link image media table | emoticons charmap | removeformat',
								}}
							/>
						</div>
					</div>

					<div className="row mb-3">
						<div className="col-md-8 text-end">
							<br/>
							<span
								role="button"
								className="p-2 text-secondary icon"
								title="Send Email"
								onClick={onSendEmailClicked}
							>
								Send Email
								<FontAwesomeIcon icon={faEnvelope}  className="fa-icon"/>
							</span>
							
							{!isUser &&<span
								role="button"
								className="p-2 text-secondary icon"
								title="Home"
								onClick={onHomeClicked}
							>
								Home
								<FontAwesomeIcon icon={faHome}  className="fa-icon"/>
							</span>
							}
						</div>
					</div>
					
					<div className="row">
						<div className="col-md-8 text-end">
							<a href="sms:2108723424" className="p-2">Or click here to Text Us</a>
						</div>
					</div>

				</form>

			</main>
		</section>
	)
}

export default ContactUs